import type { createBrowserRouter, NavigateOptions, To } from 'react-router';

type AppRouter = ReturnType<typeof createBrowserRouter>;

let router: AppRouter | undefined;

export const setAppRouter = (nextRouter: AppRouter | undefined) => {
  router = nextRouter;
};

export const getRouterLocation = () => router?.state.location ?? window.location;

// The router renders a navigation in a transition, so a component's own params can lag the URL; a URL write builds on
// the registered router's location instead. With no router registered (a spec's MemoryRouter), the caller's params do.
export const getLatestSearchParams = (own: URLSearchParams) =>
  new URLSearchParams(router ? router.state.location.search : own);

export const isRouterNavigating = () => !!router && router.state.navigation.state !== 'idle';

export const navigate = (to: To, options?: NavigateOptions) => {
  if (!router) throw new Error('The application router has not been initialized');
  return router.navigate(to, options);
};
